import * as Sentry from "@sentry/react";
import { ReactNode } from "react";
import { prepareSdkCapture } from "src/utils/sentry";
import { BaseButton } from "./BaseButton";

/** 컴포넌트 이름 정규식 */
const COMPONENT_NAME = /^[\w$]+(?=[ (@]|$)/;

/**
 * componentStack 첫 줄에서 컴포넌트 이름만 분리
 */
export const firstComponentName = (componentStack: string | undefined): string => {
  const frame = componentStack?.split("\n").find((line) => line.trim() !== "");

  return frame?.trim().replace(/^at /, "").match(COMPONENT_NAME)?.[0] ?? "unknown";
};

/**
 * 렌더 중 에러에 대한 fallback 렌더링 및 센트리로 에러 전송
 * (이벤트 핸들러나 비동기 콜백의 에러는 SDK 의 globalHandlers 가 담당)
 */
const AppErrorBoundary = ({ children }: { children: ReactNode }) => (
  <Sentry.ErrorBoundary
    beforeCapture={(_scope, error, componentStack) => {
      prepareSdkCapture(error, { render: { component: firstComponentName(componentStack) }, ui: { surface: "boundary" }, perceived: true });
    }}
    fallback={
      <div className="error-page">
        <section>
          <div className="error-icon ic-exclamation"></div>
          <div className="error-message-wrap">
            <p className="font18 font-weight-semibold mb4">화면을 표시하는 중 문제가 발생했습니다.</p>
            <p className="font15">잠시 후 다시 시도해주세요</p>
          </div>
          <div className="flex-center-center mt30">
            <BaseButton title="새로고침" className="size-medium" onClick={() => window.location.reload()}></BaseButton>
          </div>
        </section>
      </div>
    }
  >
    {children}
  </Sentry.ErrorBoundary>
);

export default AppErrorBoundary;
